var _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalTab3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 9,
    viewBox: "0 0 29 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.629,
    cy: 4.35169,
    r: 3.51985,
    fill: "#F8E7F1",
    stroke: "#8F4765",
    strokeWidth: 0.487892
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.41419,
    cy: 4.35169,
    r: 3.51985,
    fill: "#F8E7F1",
    stroke: "#8F4765",
    strokeWidth: 0.487892
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.838,
    cy: 4.35169,
    r: 3.7638,
    fill: "#8F4765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalTab3);
export default __webpack_public_path__ + "static/media/modalTab3.c599d7d9338c556cce4d84034bc07cf2.svg";
export { ForwardRef as ReactComponent };